import { request, errorText, openBlob } from "../api";

// /api/accounting/invoicing — customer credits (Guthaben), the customer account (UI-4),
// insolvency and the customer's receivables master data.
export const listCredits = params => request.get("/invoicing/credits", params);
export const offsetCredit = (id, body) => request.post(`/invoicing/credits/${id}/offset`, body);
export const refundCredit = (id, body) => request.post(`/invoicing/credits/${id}/refund`, body);
export const refundBatchXml = batchId => request.blob(`/invoicing/credits/batches/${batchId}/xml`);

export const customerAccount = id => request.get(`/invoicing/customers/${id}/account`);
export const markInsolvent = (id, body) =>
  request.post(`/invoicing/customers/${id}/insolvency`, body);
export const updateReceivablesData = (id, body) =>
  request.put(`/invoicing/customers/${id}/receivables-data`, body);

export const listBankAccounts = () => request.get("/bank/accounts");

/** Error code of a RequestError response (e.g. NO_IBAN), if the server sent one. */
export const errorCode = error =>
  error?.response?.data?.code || error?.response?.data?.errorCode || null;

/** Downloads the pain.001 file of a SEPA refund. */
export const downloadRefundXml = batch =>
  openBlob(refundBatchXml(batch._id), `pain001-${batch.messageId || batch._id}.xml`);

export { errorText, openBlob };
